<template>
  <div class="cl-mask">
    <!-- 装饰光斑 -->
    <span class="cl-blob cl-b1"></span>
    <span class="cl-blob cl-b2"></span>
    <span class="cl-blob cl-b3"></span>

    <!-- 品牌头部 -->
    <div class="cl-hero">
      <div class="cl-logo">留白</div>
      <div class="cl-hero-title">留白空间 CRM</div>
      <div class="cl-hero-sub">客户 · 房态 · 订单 一体化管理平台</div>
    </div>

    <!-- 登录卡片（底部抽屉式） -->
    <div class="cl-card">
      <div class="cl-head">
        <p class="cl-greeting">欢迎登录</p>
        <p class="cl-greeting-sub">使用员工账号登录以继续使用</p>
      </div>

      <van-cell-group class="cl-form">
        <van-field
          v-model="form.phone"
          type="tel"
          maxlength="11"
          left-icon="phone-o"
          placeholder="请输入手机号"
          clearable
        />
        <van-field
          v-model="form.password"
          :type="showPwd ? 'text' : 'password'"
          left-icon="lock"
          placeholder="请输入密码"
        >
          <template #right-icon>
            <van-icon
              :name="showPwd ? 'eye-o' : 'closed-eye'"
              class="cl-eye"
              @click="showPwd = !showPwd"
            />
          </template>
        </van-field>
      </van-cell-group>

      <div class="cl-row">
        <van-checkbox v-model="remember" class="cl-remember">记住登录</van-checkbox>
      </div>

      <div class="cl-error" v-if="error">{{ error }}</div>

      <van-button
        class="cl-btn"
        block
        :loading="loading"
        loading-text="登录中..."
        @click="onLogin"
      >登 录</van-button>

      <div class="cl-secure">
        <van-icon name="certificate" class="cl-secure-ic" />
        <span>信息加密传输 · 内部系统请勿外泄</span>
      </div>
    </div>
  </div>
</template>

<script>
import { clientPasswordLogin, fetchProfile } from '@/util/clientAuth.js'

export default {
  name: 'ClientLogin',
  data() {
    return {
      form: { phone: '', password: '' },
      showPwd: false,
      remember: true,
      loading: false,
      error: ''
    }
  },
  methods: {
    onLogin() {
      this.error = ''
      if (!/^1\d{10}$/.test(this.form.phone)) {
        this.error = '请输入正确的 11 位手机号'
        return
      }
      if (this.form.password === '') {
        this.error = '请输入密码'
        return
      }
      this.loading = true
      clientPasswordLogin({
        phone: this.form.phone,
        password: this.form.password,
        remember: this.remember
      })
        .then(res => {
          if (res && res.code === 200) {
            // P44：登录后探明角色画像（市场/财务/普通销售），供上层按端分流。
            // fetchProfile 内部已吞掉所有异常，失败时 app_scope 保持 'crm'，不影响登录。
            return fetchProfile(this.remember !== false).then(profile => {
              this.loading = false
              this.$emit('success', res.data, profile)
            })
          }
          this.loading = false
          this.error = (res && res.msg) ? res.msg : '登录失败，请重试'
        })
        .catch(() => {
          this.loading = false
          this.error = '网络异常，请稍后重试'
        })
    }
  }
}
</script>

<style>
.cl-mask {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: linear-gradient(165deg, #16245a 0%, #244a9e 48%, #3f6fd6 100%);
  animation: clFade .35s ease both;
}

@keyframes clFade { from { opacity: 0; } to { opacity: 1; } }

/* 装饰光斑 */
.cl-blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(6px);
  opacity: .22;
  pointer-events: none;
}
.cl-b1 { width: 240px; height: 240px; background: #6f9bff; top: -70px; right: -50px; }
.cl-b2 { width: 170px; height: 170px; background: #9bc0ff; bottom: 28%; left: -60px; opacity: .16; }
.cl-b3 { width: 130px; height: 130px; background: #c9dbff; top: 38%; right: -36px; opacity: .14; }

/* 头部 */
.cl-hero {
  position: relative;
  z-index: 2;
  flex: 0 0 auto;
  padding: calc(env(safe-area-inset-top, 0px) + 58px) 28px 0;
  text-align: center;
  color: #fff;
  animation: clDown .5s cubic-bezier(.2, .8, .25, 1) both;
}
@keyframes clDown {
  from { opacity: 0; transform: translateY(-14px); }
  to { opacity: 1; transform: translateY(0); }
}
.cl-logo {
  width: 64px;
  height: 64px;
  margin: 0 auto 16px;
  border-radius: 18px;
  background: rgba(255, 255, 255, .16);
  border: 1px solid rgba(255, 255, 255, .35);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 2px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, .18);
}
.cl-hero-title {
  font-size: 24px;
  font-weight: 800;
  letter-spacing: 2px;
}
.cl-hero-sub {
  margin-top: 8px;
  font-size: 13px;
  color: rgba(255, 255, 255, .78);
  letter-spacing: 1px;
}

/* 卡片（底部抽屉式） */
.cl-card {
  position: relative;
  z-index: 3;
  flex: 1 1 auto;
  margin-top: 40px;
  padding: 30px 22px calc(env(safe-area-inset-bottom, 0px) + 26px);
  background: #fff;
  border-radius: 28px 28px 0 0;
  box-shadow: 0 -12px 44px rgba(8, 18, 48, .28);
  animation: clUp .55s cubic-bezier(.2, .8, .25, 1) both;
}
@keyframes clUp {
  from { opacity: 0; transform: translateY(26px); }
  to { opacity: 1; transform: translateY(0); }
}

.cl-head { margin-bottom: 22px; }
.cl-greeting {
  font-size: 22px;
  font-weight: 700;
  color: #1d2b53;
  letter-spacing: .5px;
}
.cl-greeting-sub {
  margin-top: 6px;
  font-size: 13px;
  color: #8a93a8;
}

.cl-form { border-radius: 14px; overflow: hidden; }
.cl-form .van-cell {
  padding: 15px 14px !important;
  background: #f4f6fb;
  border-radius: 14px;
  margin-bottom: 12px;
  transition: box-shadow .2s, background .2s;
}
.cl-form .van-cell:last-child { margin-bottom: 0; }
.cl-form .van-cell:focus-within {
  background: #eef3ff;
  box-shadow: 0 0 0 2px rgba(74, 127, 224, .28);
}
.cl-form .van-field__control { font-size: 15px; color: #1d2b53; }
.cl-form .van-icon { color: #9aa3b5; font-size: 18px; }
.cl-eye { color: #9aa3b5; font-size: 18px; }

.cl-row { display: flex; align-items: center; margin: 4px 2px 6px; }
.cl-remember .van-checkbox__label { color: #5b6478; font-size: 13px; }

.cl-error {
  color: #e24b4a;
  font-size: 13px;
  min-height: 18px;
  margin: 6px 2px 10px;
}

.cl-btn {
  height: 52px;
  border: none;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 3px;
  color: #fff;
  background: linear-gradient(135deg, #2b4c9b 0%, #4a7fe0 100%);
  box-shadow: 0 12px 26px rgba(43, 76, 155, .34);
  margin-top: 4px;
}
.cl-btn:active { opacity: .92; }

.cl-secure {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 18px;
  font-size: 12px;
  color: #aab1c2;
}
.cl-secure-ic { font-size: 14px; color: #b9c0d0; }

/* 【P124】宽屏（PC 浏览器）适配：本组件是「手机版登录」形态，在 1280 宽的桌面上
   若让卡片继续 100% 拉伸，输入框/按钮会被拉成整屏宽、观感松散。
   这里在宽屏下把卡片收成手机宽度并居中，保持「PC 上也是手机版登录样式」的口径。 */
@media (min-width: 731px) {
  .cl-mask { align-items: center; }
  .cl-hero { padding: calc(env(safe-area-inset-top, 0px) + 74px) 28px 0; }
  .cl-card {
    flex: 0 0 auto;
    width: 430px;
    max-width: calc(100% - 48px);
    margin: 38px auto 0;
    padding: 30px 26px 26px;
    border-radius: 24px;
    box-shadow: 0 24px 64px rgba(8, 18, 48, .38);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ClientLogin.vue